import React from 'react';
import { Table } from 'reactstrap';
import NumericInput from '../common/forms/NumericInput';
import { FormCheckbox } from '../common/forms/FormElements';

export const USCountyGroupPayRateGrid = ({
    workTypePayRates,
    contractUnionWorkTypes,
    onPayRateChange,
    onSaturdayOTChange,
}) => (
    <Table className="table table-sm" bordered responsive>
        <thead>
            <tr>
                <th>Work Type</th>
                <th>Pay Rate</th>
                <th>Fringe Rate</th>
                <th className="text-center">Always Pays Saturday OT</th>
            </tr>
        </thead>
        <tbody>
            {contractUnionWorkTypes.map((workType) => {
                const payRate = (workTypePayRates || []).find(
                    (rate) => rate.contractUnionWorkTypeId === workType.id
                ) || { payRate: 0, fringeRate: 0 };

                return (
                    <tr key={workType.id}>
                        <td className="align-middle">{workType.description || workType.name}</td>

                        <td>
                            <NumericInput
                                id={`payRate-${workType.id}`}
                                name={`payRate-${workType.id}`}
                                value={payRate?.payRate || 0}
                                formGroupClassName="mb-0"
                                onChange={(e) =>
                                    onPayRateChange(workType.id, e.target.value, 'payRate')
                                }
                                type="number"
                                step="0.01"
                                placeholder="Enter Pay Rate"
                                required
                            />
                        </td>

                        <td>
                            <NumericInput
                                id={`fringeRate-${workType.id}`}
                                name={`fringeRate-${workType.id}`}
                                value={payRate?.fringeRate || 0}
                                formGroupClassName="mb-0"
                                onChange={(e) =>
                                    onPayRateChange(workType.id, e.target.value, 'fringeRate')
                                }
                                type="number"
                                step="0.01"
                                placeholder="Enter Fringe Rate"
                                required
                            />
                        </td>

                        <td className="text-center align-middle">
                            <FormCheckbox
                                id={`alwaysHasSaturdayOvertime-${workType.id}`}
                                name={`alwaysHasSaturdayOvertime-${workType.id}`}
                                checked={payRate?.alwaysHasSaturdayOvertime || false}
                                onChange={(e) => onSaturdayOTChange(workType.id, e.target.checked)}
                            />
                        </td>
                    </tr>
                );
            })}
        </tbody>
    </Table>
);
